/* @flow */

export default {
  off: 'off',
  debug: 'debug',
  info: 'info',
  warn: 'warn',
  error: 'error'
};
